<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <data-card color="primary" :title="$tc('common.transfer', 2)">
            <template slot="title-items">
              <v-btn icon small color="secondary" :href="printUrl" target="_blank">
                <v-icon small color="white">print</v-icon>
              </v-btn>
              <v-btn icon small color="secondary" :to="newRoute" :disabled="!isNewTransferEnable">
                <v-icon small color="white">add</v-icon>
              </v-btn>
            </template>
            <template slot="controls">
              <v-flex xs12 xl6>
                <v-layout row>
                <v-flex xs4 lg3>
                  <v-autocomplete
                    hide-details
                    prepend-inner-icon="filter_list"
                    v-model="selectedYear"
                    :items="years"
                    :label="$tc('common.year', 1)"
                    :placeholder="$tc('common.year', 1)"
                    dark
                    solo-inverted
                    flat
                    class="small"
                    clearable>
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 lg3>
                  <v-autocomplete
                    hide-details
                    prepend-inner-icon="filter_list"
                    v-model="selectedMonth"
                    :items="months"
                    :label="$tc('common.month', 1)"
                    :placeholder="$tc('common.month', 1)"
                    dark
                    solo-inverted
                    flat
                    class="small"
                    clearable>
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 lg6>
                  <v-autocomplete
                    hide-details
                    prepend-inner-icon="filter_list"
                    v-model="selectedDepartmentId"
                    :items="departmentList"
                    item-text="displayName"
                    item-value="id"
                    :label="$tc('common.department', 1)"
                    :placeholder="$tc('common.department', 1)"
                    :loading="isLoadingDepartments"
                    dark
                    solo-inverted
                    flat
                    clearable
                    class="small">
                    </v-autocomplete>
                </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 xl6>
                <v-layout row>
                <v-flex xs4 lg5>
                  <v-autocomplete
                    hide-details
                    prepend-inner-icon="filter_list"
                    v-model="selectedFacilityId"
                    :items="facilityList"
                    item-text="displayName"
                    item-value="id"
                    :label="$tc('common.facility', 1)"
                    :placeholder="$tc('common.facility', 1)"
                    :loading="isLoadingFacilities"
                    dark
                    solo-inverted
                    flat
                    :clearable="isFacilityListClearable"
                    class="small">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 lg3>
                  <v-autocomplete
                    hide-details
                    prepend-inner-icon="filter_list"
                    v-model="selectedState"
                    :items="states"
                    :label="$tc('accounting.tansferList.entryState', 1)"
                    :placeholder="$tc('accounting.tansferList.entryState', 1)"
                    dark
                    solo-inverted
                    flat
                    class="small"
                    >
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 lg3 v-if="isUserAdministrator">
                  <v-autocomplete
                    hide-details
                    prepend-inner-icon="filter_list"
                    v-model="selectedBuhaSearchState"
                    :items="buhaFilterList"
                    :label="$tc('accounting.tansferList.buhaSearch', 1)"
                    :placeholder="$tc('accounting.tansferList.buhaSearch', 1)"
                    dark
                    solo-inverted
                    flat
                    class="small"
                    >
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <data-card-search-field v-model="search"></data-card-search-field>
                </v-flex>
                </v-layout>
              </v-flex>
            </template>
            <hasy-data-table
              ref="dataTable"
              :headers="headers"
              :items="items"
              :item-actions="tableAction"
              :loading="isLoading"
              :pagination.sync="pagination"
              :selected-item.sync="selectedItem"
              @item-dblclick="editItem"
              :search="search"
              >
            </hasy-data-table>
        </data-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Api } from '@/api/apiAccess'
import Routes from '@/router/routes'
import { mapGetters } from 'vuex'
import mutationtypes from '@/store/modules/transfer/mutation-types'
import moduleNames from '@/store/moduleNames'
import { storedSelectedItemMixin, navigationBackButtonStateMixin, editSelectedItemMixin, storedPaginationMixin, storedTableSearchMixin,
  storedPropertyMixin, selectYearMixin, pageTitleMixin, snackBarMixin, confirmMixin } from '@/mixins/mixins'

const storeModule = moduleNames.TRANSFER

export default {
  mixins: [
    storedSelectedItemMixin(storeModule, mutationtypes.UPDATE_TRANSFERLISTSELECT_STATE, 'transferListSelectedState', 'selectedTransfer'),
    navigationBackButtonStateMixin(storeModule, mutationtypes.UPDATE_TRANSFERNAVIGATIONBACKBUTTON_STATE, 'transferNavigationBackButton'),
    editSelectedItemMixin(Routes.TRANSFER_DETAILS),
    storedPaginationMixin(storeModule + '/pagination'),
    storedTableSearchMixin(storeModule, mutationtypes.UPDATE_TRANSFERLISTTABLESEARCH_STATE, 'transferListTableSearchState', 'dataTableSearch'),
    storedPropertyMixin('selectedYear', storeModule, mutationtypes.UPDATE_TRANSFERLIST_SELECTED_YEAR, 'selectedYear', 'year'),
    storedPropertyMixin('selectedMonth', storeModule, mutationtypes.UPDATE_TRANSFERLIST_SELECTED_MONTH, 'selectedMonth', 'month'),
    storedPropertyMixin('selectedDepartmentId', storeModule, mutationtypes.UPDATE_TRANSFERLIST_SELECTED_DEPARTMENT, 'selectedDepartment', 'department'),
    storedPropertyMixin('selectedFacilityId', storeModule, mutationtypes.UPDATE_TRANSFERLIST_SELECTED_FACILITY, 'selectedFacility', 'facility'),
    storedPropertyMixin('selectedState', storeModule, mutationtypes.UPDATE_TRANSFERLIST_SELECTED_STATE, 'selectedState', 'state'),
    storedPropertyMixin('selectedBuhaSearchState', storeModule, mutationtypes.UPDATE_TRANSFERLIST_SELECTED_BUHA_SEARCH_STATE, 'selectedBuhaSearchState', 'buhaSearchFilter'),

    selectYearMixin,
    pageTitleMixin,
    snackBarMixin,
    confirmMixin
  ],
  data () {
    return {
      navigationBackButtonState: { isVisible: false },
      isLoading: false,
      items: [],
      loadedItems: [],
      selected: {},
      loading: false,
      headers: [
        {
          text: this.$t('accounting.tansferList.isBuha'),
          align: 'center',
          value: 'isBuha',
          dataType: 'boolean',
          width: '3%',
          editable: this.isUserAdministrator,
          contentClasses: (v, i) => { return [ !i.buhaCompleted && i.buhaRemark && this.isUserAdministrator ? 'color: yellow' : '' ] },
          evtHandlers: {
            contextmenu: (h, item, e) => { this.editItemBuha(item); e.preventDefault() },
            change: (h, item, value) => { this.onChangeIsBuha(item, value) } },
          tooltipColumn: 'buhaRemark'
        },
        {
          text: this.$t('accounting.tansferList.entryState'),
          align: 'left',
          value: 'entryState',
          width: '7%',
          contentFormat: (v) => this.$t('transferListStatus.' + v),
          dataType: 'string'
        },
        {
          text: this.$t('accounting.tansferList.voucherNumber'),
          align: 'left',
          value: 'voucherNumber',
          width: '13%',
          dataType: 'string'
        },
        {
          text: this.$t('accounting.tansferList.recipientName'),
          align: 'left',
          value: 'recipientName',
          width: '11%',
          dataType: 'string'
        },
        {
          text: this.$t('accounting.tansferList.sumTotal'),
          align: 'center',
          value: 'sumTotal',
          width: '6%',
          dataType: 'currency',
          contentAlign: 'right'
        },
        {
          text: this.$t('accounting.tansferList.entryDate'),
          align: 'left',
          value: 'entryDate',
          width: '10%',
          dataType: 'datetime',
          contentAlign: 'center'
        },
        {
          text: this.$t('accounting.tansferList.author'),
          align: 'left',
          value: 'author',
          width: '8%',
          dataType: 'string'
        },
        {
          text: this.$t('accounting.tansferList.subject'),
          align: 'left',
          value: 'subject',
          width: '17%',
          dataType: 'string',
          classes: 'wrap-header'
        },
        {
          text: this.$t('accounting.tansferList.text'),
          value: 'fullText',
          dataType: 'string',
          width: '18%'
        },
        {
          text: '',
          sortable: false,
          dataType: 'action',
          contentAlign: 'right',
          width: '4%'
        }
      ],
      tableAction: [{
        icon: 'zoom_in',
        title: this.$t('accounting.tansferList.transferDetails'),
        color: 'primary',
        to: (item) => { return { name: Routes.TRANSFER_DETAILS, params: { id: item.id } } }
      }],
      facilityList: [],
      departmentList: [],
      months: [...Array.from(new Array(12), (x, i) => {
        let objDate = new Date()
        objDate.setDate(1)
        objDate.setMonth(i)
        return {
          text: objDate.toLocaleString(this.$i18n.locale, { month: 'long' }),
          value: i + 1
        }
      })],
      isLoadingDepartments: false,
      isLoadingFacilities: false,
      states: [
        {
          text: this.$t('transferListStatus.0'),
          value: 0
        },
        {
          text: this.$t('transferListStatus.1'),
          value: 1
        },
        {
          text: this.$t('transferListStatus.4'),
          value: 4
        },
        {
          text: this.$t('transferListStatus.8'),
          value: 8
        },
        {
          text: this.$t('transferListStatus.2'),
          value: 2
        },
        {
          text: this.$t('transferListStatus.16'),
          value: 16
        }
      ],
      buhaFilterList: [
        {
          text: this.$t('transferListBuhaSearch.0'),
          value: 0
        },
        {
          text: this.$t('transferListBuhaSearch.1'),
          value: 1
        },
        {
          text: this.$t('transferListBuhaSearch.2'),
          value: 2
        },
        {
          text: this.$t('transferListBuhaSearch.3'),
          value: 3
        }
      ],
      changeDepartmentFacilityChoose: true,
      flagLoadTransfers: false,
      isNewTransferEnable: false,
      isTransferListFirstLoad: true,
      isFacilityListClearable: true
    }
  },
  computed: {
    ...mapGetters(['isUserAdministrator', { isTransferListFirstLoad: storeModule + '/isTransferListFirstLoad' }]),
    selectedDepartment () {
      let list = this.departmentList || []
      let id = this.selectedDepartmentId
      let item = list.find(i => i.id === id)
      return item
    },
    selectedFacility () {
      let list = this.facilityList || []
      let id = this.selectedFacilityId
      let item = list.find(i => i.id === id)
      return item
    },
    newRoute () {
      if (this.selectedFacilityId == null) {
        return { name: Routes.TRANSFER_NEW, params: { id: 0 } }
      } else {
        return { name: Routes.TRANSFER_NEW, params: { id: this.selectedFacilityId } }
      }
    },
    printArgs () {
      let year = this.selectedYear == null ? -1 : this.selectedYear
      let month = this.selectedMonth == null ? -1 : this.selectedMonth
      let status = this.selectedState == null ? undefined : this.selectedState
      let culture = this.$i18n.locale
      let department = this.selectedDepartment == null ? undefined : this.selectedDepartment.id
      let facility = this.selectedFacility == null ? undefined : this.selectedFacility.id

      return [year, month, department, facility, status, culture]
    },
    printUrl () {
      let paramCreator = Api.TransferParamCreator
      let args = this.printArgs
      let params = paramCreator.transferTransferList(...args)
      let relativeUrl = params.url
      let basePath = Api.BasePath

      if (relativeUrl == null || relativeUrl.length <= 0 || basePath == null || basePath.length <= 0) {
        return null
      }

      return basePath + relativeUrl
    }
  },
  watch: {
    selectedYear (v) {
      this.loadTransfers()
    },
    selectedMonth (v) {
      this.loadTransfers()
    },
    selectedDepartment (newValue, oldValue) {
      let selectDepartment = oldValue == null && newValue != null
      this.refreshDepartmentFacilityChoose(selectDepartment, false)
        .then(() => {
          if (newValue != null || this.isUserAdministrator) {
            this.loadTransfers()
          }
        })
    },
    selectedFacility (newValue, oldValue) {
      let selectFacility = oldValue == null && newValue != null
      this.isNewTransferEnable = newValue != null
      this.refreshDepartmentFacilityChoose(false, selectFacility)
        .then(() => {
          if (newValue != null || this.isUserAdministrator) {
            this.loadTransfers()
          }
        })
    },
    selectedState (v) {
      this.loadTransfers()
    },
    selectedBuhaSearchState (v) {
      this.filterBuha()
    }
  },
  created () {
    // Note: null is the default value of the store state property
    // if the select is cleared the value is undefined
    // check with === null is done to ensure that its not set when
    // the value was previously cleared but only if its the first load
    if (this.selectedYear === null) {
      this.selectedYear = new Date().getFullYear()
    }
    if (this.selectedMonth === null) {
      this.selectedMonth = new Date().getMonth() + 1
    }
    if (this.selectedState === null) {
      this.selectedState = 0
    }
    if (this.selectedBuhaSearchState === null) {
      this.selectedBuhaSearchState = 0
    }
    // set editable state of IsBuha column
    this.headers[0].editable = this.isUserAdministrator
    if (!this.isUserAdministrator) {
      // IsBuha column remove for non admins
      this.headers.shift()
    }
    // load data
    this.loadItems()
  },
  methods: {
    loadItems () {
      this.loadDepartments()
        .then(() => {
          if (this.isTransferListFirstLoad) {
            if (this.departmentList.length > 0) {
              if ((!this.selectedDepartmentId || this.selectedDepartmentId === null) && !this.isUserAdministrator) {
                this.selectedDepartmentId = this.departmentList[0].id
              }
            } else {
              this.selectedDepartmentId = null
            }
          }
          this.loadFacilities()
            .then(() => {
              if (this.isTransferListFirstLoad) {
                if ((!this.selectedDepartmentId || this.selectedDepartmentId === null) && this.facilityList.length > 0) {
                  if ((!this.selectedFacilityId || this.selectedFacilityId === null) && !this.isUserAdministrator) {
                    this.selectedFacilityId = this.facilityList[0].id
                  }
                } else {
                  this.selectedFacilityId = null
                }
              }
              this.flagLoadTransfers = true
              this.loadTransfers()
            })
        })
    },
    loadFacilities () {
      this.isLoadingFacilities = true
      let facilityApi = Api.Facility
      // 5 = UserRoleType.TransferAuthorized
      return facilityApi.facilityGetAllAuthorizedActive(5)
        .then(r => {
          this.facilityList = r.data
          return Promise.resolve()
        },
        err => {
          return Promise.reject(err)
        })
        .finally(() => {
          this.isLoadingFacilities = false
        })
    },
    loadDepartments () {
      this.isLoadingDepartments = true
      let departmentApi = Api.Department
      // 5 = UserRoleType.TransferAuthorized
      return departmentApi.departmentGetAllAuthorizedActive(5)
        .then(r => {
          this.departmentList = r.data
          return Promise.resolve()
        },
        err => {
          return Promise.reject(err)
        })
        .finally(() => {
          this.isLoadingDepartments = false
          this.isFacilityListClearable = this.isUserAdministrator || this.departmentList.length > 0
        })
    },
    loadTransfers () {
      if (!this.flagLoadTransfers || (this.selectedDepartment == null && this.selectedFacility == null && !this.isUserAdministrator)) {
        this.items = []
        return Promise.resolve()
      }

      let year = this.selectedYear == null ? -1 : this.selectedYear
      let month = this.selectedMonth == null ? -1 : this.selectedMonth
      let department = this.selectedDepartment == null ? undefined : this.selectedDepartment.id
      let facility = this.selectedFacility == null ? undefined : this.selectedFacility.id
      let status = this.selectedState == null ? undefined : this.selectedState

      this.isLoading = true
      let ep = Api.Transfer
      return ep.transferGetAllAuthorized(year, month, department, facility, status)
        .then(r => {
          this.loadItems = r.data
          this.filterBuha()
          return Promise.resolve()
        },
        err => {
          return Promise.reject(err)
        })
        .finally(() => {
          if (this.isTransferListFirstLoad) {
            this.SetPaginationSortBy('entryDate', true)
            this.$store.commit(storeModule + '/' + mutationtypes.UPDATE_TRANSFERLISTFIRSTLOAD_STATE, { transferFirstLoad: false })
          }
          this.isLoading = false
          this.isTransferListFirstLoad = false
          this.restoreSelectedItem()
        })
    },
    refreshDepartmentFacilityChoose (selectDepartment, selectFacility) {
      let depIsNull = this.selectedDepartment == null
      let facIsNull = this.selectedFacility == null

      if ((!depIsNull && facIsNull) || (!facIsNull && depIsNull)) {
      } else if (depIsNull && facIsNull) {
        this.$nextTick(() => {
          if (!this.isUserAdministrator) {
            if (Array.isArray(this.departmentList) && this.departmentList.length > 0) {
              this.selectedDepartmentId = this.departmentList[0].id
            } else {
              this.selectedFacilityId = this.facilityList[0].id
            }
          }
          return Promise.resolve()
        })
      } else if (!depIsNull && !facIsNull) {
        if (selectDepartment) {
          this.$nextTick(() => {
            this.selectedFacilityId = null
            return Promise.resolve()
          })
        } else if (selectFacility) {
          this.$nextTick(() => {
            this.selectedDepartmentId = null
            return Promise.resolve()
          })
        }
      }
      return Promise.resolve()
    },
    onChangeIsBuha (transferItem, newValue) {
      if (transferItem.isBuha === true) {
        this.$confirm(this.$t('accounting.tansferList.rejectIsBuhaConfirm'), { title: this.$t('accounting.tansferList.rejectIsBuha') })
          .then((r) => {
            if (!r) {
              const oldVal = transferItem.isBuha
              transferItem.isBuha = !oldVal
              this.$nextTick(() => { transferItem.isBuha = oldVal })
            } else {
              this.changeIsBuha(transferItem, newValue)
            }
          })
      } else {
        this.changeIsBuha(transferItem, newValue)
      }
    },
    changeIsBuha (transferItem, newValue) {
      transferItem.isBuha = newValue
      let api = Api.Transfer
      api.transferSetIsBuha(transferItem.id, newValue)
        .then(r => {
          this.$nextTick(() => {
            this.showStatusMessage(this.$t('common.dataSaved'))
            this.filterBuha()
          })
        })
    },
    editItemBuha (item) {
      let buhaEditRoute = { name: Routes.TRANSFER_DETAILS, params: { id: item.id, setUiFocusMode: 1 } }
      this.$router.push(buhaEditRoute)
    },
    filterBuha () {
      let buhaSearchFilter = this.selectedBuhaSearchState == null ? 0 : this.selectedBuhaSearchState

      switch (buhaSearchFilter) {
        case 0:
          this.items = Array.from(this.loadItems)
          break
        case 1:
          this.items = this.loadItems.filter(x => x.isBuha)
          break
        case 2:
          this.items = this.loadItems.filter(x => !x.isBuha)
          break
        case 3:
          this.items = this.loadItems.filter(x => !x.buhaCompleted && x.buhaRemark && this.isUserAdministrator)
          break
      }
    }
  }
}
</script>
